import React, { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { UserResponse } from '@/client/types.gen';

// Convert createdAt from ISO string to Unix timestamp (seconds)
const convertToUnixTimestamp = (dateString: string): number => {
  if (!dateString) return Math.floor(Date.now() / 1000);
  return Math.floor(new Date(dateString).getTime() / 1000);
};

interface IntercomProviderProps {
  children: React.ReactNode;
  user?: UserResponse | null;
}

export function IntercomProvider({ children, user }: IntercomProviderProps) {
  useEffect(() => {
    // Initialize Intercom with or without user data
    if (user) {
      // Initialize with user data when authenticated
      Intercom({
        app_id: 'poeqdwbz',
        user_id: user.user_id,
        name: user.name,
        email: user.email,
        // If we don't have created_at, use current time
        created_at: Math.floor(Date.now() / 1000),
        companies: [
          {
            company_id: user.organisation_id,
            name: 'Organization',
          },
        ],
      });
    } else {
      // Initialize without user data for unauthenticated visitors
      Intercom({
        app_id: 'poeqdwbz',
      });
    }

    return () => {
      // Clean up Intercom when component unmounts
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [user]);

  return <>{children}</>;
}
